
    var riot = require('riot')
    //src: starling/src/tags/menu/items/menu-item-create-region.html
riot.tag2('menu-item-create-region',
  '<svg class="floating-menu_icon"> <use xlink:href="#create-region-icon"></use> </svg> <span class="floating-menu_label">Create a region</span>',
  '',
  'class="{opts.classes} floating-menu_item" onclick="{createRegion}"', function(opts) {
'use strict';

var _this = this;

var _regionUi = require('lib/region-ui');

var _constants = require('lib/constants.js');

var _util = require('lib/util');

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var canvas = this.parent.opts.canvas;

this.createRegion = function (e) {
  e.stopPropagation();
  e.preventDefault();

  var _canvas$getMatrix = canvas.getMatrix(),
      scale = _canvas$getMatrix.scale,
      tx = _canvas$getMatrix.tx,
      ty = _canvas$getMatrix.ty;

  var x = (e.clientX - tx) / scale;
  var y = (e.clientY - ty) / scale;

  var region = _regionUi.regionUI.createRegion({
    top: y,
    left: x,
    right: x + _constants.REGION_DEFAULT_SIZE.X,
    bottom: y + _constants.REGION_DEFAULT_SIZE.Y
  });
  _regionUi.regionUI.selectRegion(region.id);

  _eventTracking2.default.track({
    category: (0, _util.getTrackingLabel)(_this.parent),
    action: 'Create Region',
    label: 'Create'
  });

  _this.parent.hide();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('menu-item-create-region')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/menu/items/menu-item-create-region.html
// module id = 706
// module chunks = 0